import {
    ArrowDownward,
    ArrowUpward,
    DeleteOutline,
} from "@mui/icons-material";
import { Box, Button, Chip, Tooltip, Typography } from "@mui/material";

import SlotMetricaSelector from "../../../components/slotMetricaSelector";
import ItemNamesInput from "./itemNamesInput";

// mesmo componente serve leitura e edição; reordenação por botões (sem dnd)
export default function SlotRow({
    slot,
    aba,
    sugestoes,
    notify,
    mostrarTodasAbas,
    onChangeName,
    onChangeItems,
    onMover,
    onRemover,
    podeSubir,
    podeDescer,
    somenteLeitura = false,
    styles,
}) {
    const semItens = Boolean(slot.name?.trim()) && (slot.items || []).length === 0;

    if (somenteLeitura) {
        const itens = [...(slot.items || []), ...(slot.rawExtras || []).map((e) => e.value)];

        return (
            <Box sx={styles.slotRow}>
                <Box sx={styles.colSlot}>
                    <Box sx={styles.caixaCampoLeitura}>
                        <Typography sx={styles.slotChaveMono}>{slot.name}</Typography>
                    </Box>
                </Box>

                <Box sx={styles.colItens}>
                    <Box sx={styles.caixaCampoLeitura}>
                        {itens.length === 0 ? (
                            <Typography variant="caption" color="text.disabled">
                                sem itens
                            </Typography>
                        ) : (
                            itens.map((item, index) => (
                                <Chip
                                    key={`${slot.id}-${index}`}
                                    size="small"
                                    label={String(item)}
                                    sx={styles.chipItem}
                                />
                            ))
                        )}
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={styles.slotRow}>
            <Box sx={styles.colSlot}>
                <Box sx={styles.caixaCampo}>
                    <SlotMetricaSelector
                        value={slot.name}
                        onChange={onChangeName}
                        aba={aba}
                        notify={notify}
                        mostrarTodasAbas={mostrarTodasAbas}
                    />
                </Box>
            </Box>

            <Box sx={styles.colItens}>
                <Tooltip
                    title={semItens ? "Sem itens, esta métrica não será salva" : ""}
                    placement="top-start"
                >
                    <Box
                        sx={{
                            ...styles.caixaCampo,
                            ...(semItens && {
                                borderColor: "warning.main",
                                "&:hover": { borderColor: "warning.main" },
                            }),
                        }}
                    >
                        <ItemNamesInput
                            value={slot.items}
                            onChange={onChangeItems}
                            sugestoes={sugestoes}
                            styles={styles}
                        />
                    </Box>
                </Tooltip>
            </Box>

            <Box sx={styles.colAcoes}>
                <Button
                    size="small"
                    disabled={!podeSubir}
                    onClick={() => onMover(-1)}
                    sx={styles.botaoAcaoLinha}
                >
                    <ArrowUpward sx={{ fontSize: "0.9rem" }} />
                </Button>
                <Button
                    size="small"
                    disabled={!podeDescer}
                    onClick={() => onMover(1)}
                    sx={styles.botaoAcaoLinha}
                >
                    <ArrowDownward sx={{ fontSize: "0.9rem" }} />
                </Button>
                <Button
                    size="small"
                    onClick={onRemover}
                    startIcon={<DeleteOutline sx={{ fontSize: "0.9rem" }} />}
                    sx={styles.botaoAcaoLinhaPerigo}
                >
                    Remover
                </Button>
            </Box>
        </Box>
    );
}
